import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-266ec438"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar is-light has-shadow" }
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "navbar-start" }
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = ["href", "onClick"]
const _hoisted_11 = { class: "navbar-end" }
const _hoisted_12 = {
  class: "navbar-item",
  href: "https://github.com/zazuko/cube-creator/wiki",
  target: "_blank",
  rel: "noopener noreferrer nofollow"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Help", -1))
const _hoisted_14 = { class: "navbar-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_sign_out_button = _resolveComponent("sign-out-button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-item",
        to: { name: 'Home' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Cube Creator ")
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        role: "button",
        class: "navbar-burger",
        "aria-label": "menu",
        "aria-expanded": "false",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-menu", { 'is-active': _ctx.isOpen }])
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: { name: 'CubeProjects' },
          custom: ""
        }, {
          default: _withCtx(({ href, navigate, route }) => [
            _createElementVNode("a", {
              href: href,
              onClick: navigate,
              class: _normalizeClass(["navbar-item", { 'is-active': _ctx.isRouteActive(route, _ctx.$route) }])
            }, " Cube Projects ", 10, _hoisted_8)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'SharedDimensions' },
          custom: ""
        }, {
          default: _withCtx(({ href, navigate, route }) => [
            _createElementVNode("a", {
              href: href,
              onClick: navigate,
              class: _normalizeClass(["navbar-item", { 'is-active': _ctx.isRouteActive(route, _ctx.$route) }])
            }, " Shared Dimensions ", 10, _hoisted_9)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'Hierarchies' },
          custom: ""
        }, {
          default: _withCtx(({ href, navigate, route }) => [
            _createElementVNode("a", {
              href: href,
              onClick: navigate,
              class: _normalizeClass(["navbar-item", { 'is-active': _ctx.isRouteActive(route, _ctx.$route) }])
            }, " Hierarchies ", 10, _hoisted_10)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("a", _hoisted_12, [
          _createVNode(_component_o_icon, { icon: "question-circle" }),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_sign_out_button)
        ])
      ])
    ], 2)
  ]))
}